const onInit = {
  data() {
    return {
      formSearch: {},
      // 模块名
      moduleName: "",
      // 查询表格数据的方法名
      moduleFunName: "",
      //表单操作方法名
      handleFormFunName: "",
      // 禁用方法名
      handleForbiddenName: "",
      // 删除方法名
      handleDeleteName: "",
      pageData: {
        list: [],
        total: 0,
        loading: false,
        pageSize: 9999,
        currentPage: 1,
        pagination: true,
      },
      popVisible: false,
      viewVisible: false,
      handleType: "",
      title: "",
      formInfo: {},
      deleteParams: {},
      delay: false,
    };
  },
  created() {
    if (!this.delay) {
      this.fetchTableList();
    }
  },
  methods: {
    // 页面数据数量变换
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      console.log("11111111111" + val);
      this.pageData.currentPage = 1;
      this.fetchTableList();
    },
    // 当前页码变换
    handleCurrentChange(val) {
      console.log("111112222222221:" + val);

      this.pageData.currentPage = val;
      this.fetchTableList1();
    },
    // 页面表格勾选数据变换时
    handleSelectionChange() {},
    fetchTableAfter() {},
    beforeSearch() {
      console.log("111112出发点啊");
      this.pageData.currentPage = 1;
      this.fetchTableList();
    },
    fetchTableList1() {
      const params = {
        pageIndex: this.pageData.currentPage,
        pageSize: this.pageData.pageSize,
      };
      try {
        this.pageData.loading = true;
        this.$api[this.moduleName]
          [this.moduleFunName]({ ...this.formSearch, ...params })
          .then((res) => {
            let data = [];
            if (res.traceId) {
              data = res.data;
            } else {
              data = res;
            }
            if (data.list) {
              this.pageData = {
                ...data,
                loading: false,
                pageSize: this.pageData.pageSize,
                currentPage: this.pageData.currentPage,

                pagination: true,
              };
            } else {
              this.pageData = {
                ...this.pageData,
                list: data,
                pagination: false,
                loading: false,
              };
            }
            console.log(this.pageData);
            this.fetchTableAfter();
          })
          .catch(() => {
            this.pageData = {
              ...this.pageData,
              list: [],
              pagination: false,
              loading: false,
            };
          });
      } catch (error) {
        this.pageData.loading = false;
      }
    },
    // 查询列表数据
    fetchTableList() {
      console.log("请求");
      const params = {
        pageIndex: this.pageData.currentPage,
        pageSize: this.pageData.pageSize,
      };
      try {
        this.pageData.loading = true;
        this.$api[this.moduleName]
          [this.moduleFunName]({ ...this.formSearch, ...params })
          .then((res) => {
            let data = [];
            if (res.traceId) {
              data = res.data;
            } else {
              data = res;
            }
            if (data.list) {
              this.pageData = {
                ...data,
                loading: false,
                currentPage: this.pageData.currentPage,
                pageSize: this.pageData.pageSize,
                pagination: true,
              };
            } else {
              this.pageData = {
                ...this.pageData,
                list: data,
                pagination: false,
                loading: false,
              };
            }
            console.log(this.pageData);
            this.fetchTableAfter();
          })
          .catch(() => {
            this.pageData = {
              ...this.pageData,
              list: [],
              pagination: false,
              loading: false,
            };
          });
      } catch (error) {
        this.pageData.loading = false;
      }
    },
    // 表格项格式化
    formatter(row, column, cellValue, index) {
      let result = "";
      result = cellValue || "-";
      if (cellValue === 0) {
        result = cellValue;
      }
      return result;
    },
    beforeReset() {},
    // 查询表单重置
    resetForm(formName) {
      console.log("重新hi");
      this.beforeReset();
      this.$refs[formName] &&
        this.$refs[formName].fields.forEach((item) => {
          this.$set(this.formSearch, item.prop, "");
        });
      this.$refs[formName].resetFields();
      this.formSearch.trunkIdProvider = null;
      this.formSearch.name = null;
      this.formSearch.regionAgentId = null;
      this.pageData.currentPage = 1;
      this.formSearch.positionType = null;
      this.formSearch.terminalType = null;
      this.formSearch.description = undefined;
      this.fetchTableList();
    },
    beforeClose() {
      this.formInfo = {};
    },
    // 弹出界面关闭时刷新列表数据
    close() {
      this.beforeClose();
      this.popVisible = false;
      this.fetchTableList();
    },
    closeView() {
      this.viewVisible = false;
    },
    // 列表项删除
    handleDelete(item) {
      this.$confirm("此操作将永久删除该项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: (action) => {
          if (action === "confirm") {
            const params = this.beforeDelete(item);
            this.$api[this.moduleName]
              [this.handleDeleteName || this.handleFormFunName](
                params || this.deleteParams
              )
              .then((data) => {
                this.$message({
                  message: "删除成功",
                  type: "success",
                  duration: 3 * 1000,
                });
                this.fetchTableList();
              })
              .catch(() => {});
          } else {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          }
        },
      });
    },
    // 禁用
    handleForbidden(detail) {
      const params = this.beforeForbidden(detail);
      this.$confirm(params.tip, "提示", {
        confirmButtonText: params.confirmButtonText || "确定",
        cancelButtonText: params.cancelButtonText || "取消",
        type: params.type || "warning",
      }).then(() => {
        this.$api[this.moduleName]
          [this.handleForbiddenName](params.data)
          .then((data) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.fetchTableList();
          });
      });
    },
    // 新增
    handleAdd(type, refName) {
      this.handleType = type;
      this.popVisible = true;
      if (refName) {
        this.$nextTick(() => {
          this.$refs[refName].init();
        });
      }
    },
    // 编辑
    handleEdit(type, refName, item) {
      this.handleType = type;
      this.popVisible = true;
      if (refName) {
        this.$nextTick(() => {
          this.$refs[refName].init(item, this.handleType);
        });
      }
    },
    handleForm(row) {
      this.beforeSubmit(row);
      this.$api[this.moduleName]
        [this.handleFormFunName]({ ...this.formInfo })
        .then((data) => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.close();
        })
        .catch(() => {});
    },
    beforeSubmit() {},
    beforeDelete() {},
  },
};

export default onInit;
